// must match OrderByLayerNullsOrder.java
export const NULLS_LARGE = 'nulls_large';
export const NULLS_SMALL = 'nulls_small';
export const NULLS_FIRST = 'nulls_first';
export const NULLS_LAST = 'nulls_last';
